(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not([data-mt-init])');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      el.dataset.mtInit = '1';
      obs.observe(el);
    });
  }

  function initPasosLinea(root) {
    (root || document).querySelectorAll('.mt-pasos-wrap:not([data-mt-init])').forEach(function (wrap) {
      wrap.dataset.mtInit = '1';
      var fill = wrap.querySelector('.mt-pasos-linea-fill');
      if (!fill) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fill.style.width = '100%';
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      obs.observe(wrap);
    });
  }

  function initCifras(root) {
    (root || document).querySelectorAll('.mt-count:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      var target = parseFloat(el.dataset.target || '0');
      var decimals = (el.dataset.target || '').indexOf('.') > -1 ? 1 : 0;
      var suffix = el.dataset.suffix || '';
      // El HTML ya trae la cifra real (por si el JS no llega); la animación arranca desde 0.
      if (!('IntersectionObserver' in window)) return;
      el.textContent = (decimals ? (0).toFixed(decimals) : 0) + suffix;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          var start = null;
          var duration = 1400;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var val = target * eased;
            el.textContent = (decimals ? val.toFixed(decimals) : Math.round(val)) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });
      obs.observe(el);
    });
  }

  function initVariantes(root) {
    (root || document).querySelectorAll('.mt-variantes:not([data-mt-init])').forEach(function (wrap) {
      wrap.dataset.mtInit = '1';
      var swatches = wrap.querySelectorAll('.mt-swatch');
      var tamanos = wrap.querySelectorAll('.mt-tamano-btn');
      var precio = wrap.querySelector('.mt-variantes-precio');

      function actualizarImagen() {
        var color = wrap.querySelector('.mt-swatch.mt-activa');
        if (!color) return;
        var colorId = color.dataset.color;
        wrap.querySelectorAll('.mt-variantes-media img').forEach(function (img) {
          img.classList.toggle('mt-activa', img.dataset.color === colorId);
        });
        var nombre = wrap.querySelector('.mt-color-nombre');
        if (nombre && color.dataset.nombre) nombre.textContent = color.dataset.nombre;
      }

      function actualizarPrecio() {
        var tam = wrap.querySelector('.mt-tamano-btn.mt-activa');
        if (tam && precio) precio.textContent = tam.dataset.precio || '';
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('mt-activa'); });
          sw.classList.add('mt-activa');
          actualizarImagen();
        });
      });
      tamanos.forEach(function (btn) {
        btn.addEventListener('click', function () {
          tamanos.forEach(function (t) { t.classList.remove('mt-activa'); });
          btn.classList.add('mt-activa');
          actualizarPrecio();
        });
      });
      actualizarImagen();
      actualizarPrecio();
    });
  }

  function initHeroWipe(root) {
    (root || document).querySelectorAll('.mt-wipe:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      var handle = el.querySelector('.mt-wipe-handle');
      if (!handle) return;
      var wrap = el.closest('.mt-hero') || el.parentElement;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var MIN = 6, MAX = 94, REST = 8;
      var current = REST;
      var pendingX = null;
      var raf = null;
      var easeTimer = null;

      function setX(v) {
        current = Math.max(MIN, Math.min(MAX, v));
        el.style.setProperty('--mt-x', current.toFixed(2));
      }
      function setTilt(deg) {
        handle.style.setProperty('--mt-tilt', deg.toFixed(2));
      }
      function pctFromClientX(clientX) {
        var r = el.getBoundingClientRect();
        if (!r.width) return current;
        return ((clientX - r.left) / r.width) * 100;
      }
      function stopEasing() {
        if (easeTimer) { clearTimeout(easeTimer); easeTimer = null; }
        el.classList.remove('mt-wipe-easing');
      }
      function frame() {
        raf = null;
        if (pendingX === null) return;
        var x = pendingX;
        pendingX = null;
        var delta = x - current;
        setX(x);
        setTilt(Math.max(-16, Math.min(16, delta * 2.4)));
      }
      function onPointer(clientX) {
        stopEasing();
        el.classList.add('mt-wipe-active', 'mt-wipe-touched');
        pendingX = pctFromClientX(clientX);
        if (!raf) raf = requestAnimationFrame(frame);
      }
      function release() {
        el.classList.remove('mt-wipe-active');
        el.classList.add('mt-wipe-easing');
        setX(REST);
        setTilt(0);
        easeTimer = setTimeout(function () { el.classList.remove('mt-wipe-easing'); }, 750);
      }

      setX(REST);

      if (!reduced) {
        wrap.addEventListener('mousemove', function (e) { onPointer(e.clientX); });
        wrap.addEventListener('mouseleave', release);
        wrap.addEventListener('touchmove', function (e) {
          if (e.touches && e.touches[0]) { onPointer(e.touches[0].clientX); }
        }, { passive: true });
        wrap.addEventListener('touchend', release);
        wrap.addEventListener('touchcancel', release);

        var introDone = false;
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || introDone) return;
            introDone = true;
            obs.unobserve(entry.target);
            el.classList.add('mt-wipe-easing');
            setTimeout(function () { setX(32); setTilt(10); }, 500);
            setTimeout(function () { setX(REST); setTilt(0); }, 1500);
            setTimeout(function () { el.classList.remove('mt-wipe-easing'); }, 2300);
          });
        }, { threshold: 0.4 });
        obs.observe(el);
      }
    });
  }

  function initHistoria(root) {
    (root || document).querySelectorAll('.mt-historia:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      if (!window.gsap || !window.ScrollTrigger) return;
      gsap.registerPlugin(ScrollTrigger);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setActiveImg(key) {
        el.querySelectorAll('.mt-historia-img').forEach(function (img) {
          img.classList.toggle('mt-historia-img-activa', img.dataset.historiaImg === key);
        });
      }
      function setColors(bg, fg) {
        if (bg) el.style.backgroundColor = bg;
        if (fg) el.style.color = fg;
      }

      el.querySelectorAll('[data-historia-act]').forEach(function (actEl) {
        var key = actEl.dataset.historiaAct;
        var bg = actEl.dataset.color;
        var fg = actEl.dataset.colorTexto;
        var applyState = function () {
          if (key !== 'uso') setActiveImg(key);
          setColors(bg, fg);
        };
      ScrollTrigger.create({ trigger: actEl, start: 'top 78%', end: 'bottom 22%', onEnter: applyState, onEnterBack: applyState });
        var targets = actEl.querySelectorAll('.mt-eyebrow, .mt-h2, .mt-body, .mt-historia-beneficio, .mt-historia-img-movil');
        if (targets.length) {
          gsap.fromTo(targets, { opacity: 0, y: reduced ? 0 : 26 }, {
            opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', stagger: 0.08,
            scrollTrigger: { trigger: actEl, start: 'top 78%', toggleActions: 'play none none reverse' }
          });
        }
      });

      el.querySelectorAll('[data-historia-substep]').forEach(function (subEl) {
        var key = subEl.dataset.historiaSubstep;
        var applyState = function () { setActiveImg(key); };
        ScrollTrigger.create({ trigger: subEl, start: 'top 55%', end: 'bottom 45%', onEnter: applyState, onEnterBack: applyState });

        var targets = subEl.querySelectorAll('h3, p, .mt-historia-substep-num, .mt-historia-img-movil');
        gsap.fromTo(targets, { opacity: 0, y: reduced ? 0 : 22 }, {
          opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', stagger: 0.06,
          scrollTrigger: { trigger: subEl, start: 'top 78%', toggleActions: 'play none none reverse' }
        });
      });

      var visualInner = el.querySelector('.mt-historia-visual-inner');
      if (!reduced && visualInner) {
        gsap.to(visualInner, {
          rotateZ: 5, scale: 1.045, ease: 'none',
          scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.6 }
        });
      }
    });
  }

  function initExpansion(root) {
    (root || document).querySelectorAll('.mt-expansion:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      if (!window.gsap || !window.ScrollTrigger) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      gsap.registerPlugin(ScrollTrigger);

      var media = el.querySelector('.mt-expansion-media');
      if (!media) return;
      var img = el.querySelector('.mt-expansion-media-inner img');
      var overlay = el.querySelector('.mt-expansion-overlay');
      var inicio = parseFloat(getComputedStyle(media).getPropertyValue('--mt-exp'));
      if (isNaN(inicio)) inicio = 20;

      var tl = gsap.timeline({
        scrollTrigger: { trigger: media, start: 'top 88%', end: 'center 52%', scrub: 0.5 }
      });
      tl.fromTo(media, { '--mt-exp': inicio }, { '--mt-exp': 0, ease: 'none' }, 0);
      if (img) tl.fromTo(img, { scale: 1.14 }, { scale: 1, ease: 'none' }, 0);

      if (overlay) {
        gsap.fromTo(overlay, { opacity: 0, y: 24 }, {
          opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
          scrollTrigger: { trigger: media, start: 'center 60%', toggleActions: 'play none none reverse' }
        });
      }
    });
  }

  function initZoom(root) {
    (root || document).querySelectorAll('.mt-zoom:not([data-mt-zoom])').forEach(function (el) {
      el.dataset.mtZoom = '1';
      if (!window.gsap || !window.ScrollTrigger) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(el, { scale: 0.9 }, {
        scale: 1, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top 92%', end: 'top 40%', scrub: 0.4 }
      });
    });
  }

  function initHeroParallax(root) {
    (root || document).querySelectorAll('.mt-hero:not([data-historia-parallax])').forEach(function (heroEl) {
      heroEl.dataset.historiaParallax = '1';
      if (!window.gsap || !window.ScrollTrigger) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      gsap.registerPlugin(ScrollTrigger);
      var media = heroEl.querySelector('.mt-hero-media');
      if (!media) return;
      gsap.to(media, {
        yPercent: 12, ease: 'none',
        scrollTrigger: { trigger: heroEl, start: 'top top', end: 'bottom top', scrub: true }
      });
    });
  }

  function initBotonMagnetico(root) {
    (root || document).querySelectorAll('.mt-btn-magnet:not([data-mt-init])').forEach(function (btn) {
      btn.dataset.mtInit = '1';
      if (window.matchMedia('(pointer: coarse)').matches) return;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.28;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = 'translate(0,0)';
      });
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.nodeType === 1) ? e.target : document;
    initReveals(root);
    initPasosLinea(root);
    initCifras(root);
    initVariantes(root);
    initHeroWipe(root);
    initHistoria(root);
    initExpansion(root);
    initZoom(root);
    initHeroParallax(root);
    initBotonMagnetico(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  document.addEventListener('shopify:section:load', initTodo);
  document.addEventListener('shopify:section:unload', function () {
    if (!window.ScrollTrigger) return;
    ScrollTrigger.getAll().forEach(function (st) {
      if (st.trigger && !document.body.contains(st.trigger)) st.kill();
    });
  });
})();
